export function arraysEqual(a, b) {
    if (a.length != b.length)
        return false;
    for (let i = a.length - 1; i >= 0; i--)
        if (a[i] !== b[i])
            return false;
    return true;
}
export function array_uniq(array) {
    const map = {};
    for (const x of array)
        map[x] = true;
    if (array.length > 0 && typeof array[0] === 'number')
        return Object.keys(map).map((x) => ~~x);
    return Object.keys(map);
}
export function removeDuplicates(arr) {
    const result = [];
    const duplicatesIndices = [];
    // Перебираем каждый элемент в исходном массиве
    arr.forEach((current, index) => {
        if (duplicatesIndices.includes(index))
            return;
        result.push(current);
        // Сравниваем каждый элемент в массиве после текущего
        for (let comparisonIndex = index + 1; comparisonIndex < arr.length; comparisonIndex++) {
            const comparison = arr[comparisonIndex];
            const currentKeys = Object.keys(current);
            const comparisonKeys = Object.keys(comparison);
            // Проверяем длину массивов
            if (currentKeys.length !== comparisonKeys.length)
                continue;
            // Проверяем значение ключей
            const currentKeysString = currentKeys.sort().join('').toLowerCase();
            const comparisonKeysString = comparisonKeys
                .sort()
                .join('')
                .toLowerCase();
            if (currentKeysString !== comparisonKeysString)
                continue;
            // Проверяем индексы ключей
            let valuesEqual = true;
            for (let i = 0; i < currentKeys.length; i++) {
                const key = currentKeys[i];
                //@ts-ignore
                if (current[key] !== comparison[key]) {
                    valuesEqual = false;
                    break;
                }
            }
            if (valuesEqual)
                duplicatesIndices.push(comparisonIndex);
        }
    });
    return result;
}
/**
 * @function
 * @param list: массив элементов, которые могут быть null | undefined
 * @return чистый массив из элементов
 */
export function removeNulls(list) {
    return list.filter((x) => x != null);
}
export const isArray = (obj) => {
    const toString = {}.toString;
    return toString.call(obj) == '[object Array]';
};
